import React from 'react';
import { describe } from 'react-desc';
import DSInput from '../../Input/DSInput.js';
import { DateInputs } from './DateInputs.js';
import { defaultProps, props } from './props.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '../../Input/InputImpl.js';
import '@babel/runtime/helpers/esm/typeof';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import 'prop-types';
import 'lodash';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import '../../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../../Input/showEllipsis.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'moment';
import './utils.js';
import '@elliemae/ds-utilities/timeUtils';
import '@elliemae/ds-utilities/utils';
import './helpers.js';
import './styled.js';
import 'styled-components';
import '@elliemae/ds-grid';
import './propsTypes.js';

var DSDateInputV2 = function DSDateInputV2(_ref) {
  var onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDateChange = _ref.onDateChange,
      onKeyDown = _ref.onKeyDown,
      onError = _ref.onError,
      value = _ref.value,
      disabled = _ref.disabled,
      containerProps = _ref.containerProps,
      tabIndex = _ref.tabIndex,
      innerRef = _ref.innerRef;
  return /*#__PURE__*/React.createElement(DSInput, {
    innerRef: innerRef,
    containerProps: containerProps,
    customInputType: function customInputType(_ref2) {
      var ir = _ref2.innerRef;
      return /*#__PURE__*/React.createElement(DateInputs, {
        disabled: disabled,
        innerRef: ir,
        onBlur: onBlur,
        onChange: onChange,
        onDateChange: onDateChange,
        onCustomKeyDown: onKeyDown,
        onError: onError,
        time: value,
        tabIndex: tabIndex
      });
    },
    disableTooltip: false,
    disabled: disabled,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    value: value,
    tabIndex: tabIndex
  });
};

DSDateInputV2.defaultProps = defaultProps;
DSDateInputV2.propTypes = props;
var DSDateInputV2WithSchema = describe(DSDateInputV2);
DSDateInputV2WithSchema.propTypes = props;

export { DSDateInputV2, DSDateInputV2WithSchema };
//# sourceMappingURL=DSDateInput.js.map
